// extracted by mini-css-extract-plugin
export default {"header-img":"Carte_header-img__SEcCk","description-field":"Carte_description-field__0C0S3"};